import localAxios from '../localAxios';
import { acceptTeamInviteUrl } from './urls';

interface AcceptInviteParams {
  inviteId: string;
  teamId: string;
}

export async function acceptTeamInvite({
  inviteId,
  teamId,
}: AcceptInviteParams) {
  const url = acceptTeamInviteUrl({ inviteCode: inviteId });
  const { data } = await localAxios.post(url.href, { teamId });
  return data;
}
